export interface ISearchConfig {
    MaintCode: ISearchTypeConfig;
    RouteCode: ISearchTypeConfig;
    InfraCode: ISearchTypeConfig;
    LandCode: ISearchTypeConfig;
    TaskID: ISearchTypeConfig;
    AdminAreaDescr: ISearchTypeConfig;
    Postcode: ISearchTypeConfig;
    Settlement: ISearchTypeConfig;
    GridRef: ISearchTypeConfig;
}

export interface ISearchTypeConfig {
    SearchTypeName: string;
    IncludeInBasicSearch: boolean;
    IncludeInAdvancedSearch: boolean;
    MapZoomForResult: number;
}

export class SearchInitialConfig {

    // ----------------------------------------------------------- //
    // MAIN CONFIG
    static defaultConfig: ISearchConfig = {
        MaintCode: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'MaintCode'
        },
        RouteCode: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'RouteCode'
        },
        InfraCode: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'InfraCode'
        },
        LandCode: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'LandCode'
        },
        TaskID: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'TaskID'
        },
        AdminAreaDescr: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'AdminAreaDescr'
        },
        Postcode: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'Postcode'
        },
        Settlement: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'Settlement'
        },
        GridRef: {
            IncludeInAdvancedSearch: true, IncludeInBasicSearch: true, MapZoomForResult: 12, SearchTypeName: 'GridRef'
        }
    };
}